import axios from 'axios'

export default {
    get: () => axios.get('products'),
    getFiltered: (data) => axios.post('products', data),
    store: (data) => axios.post('products/store', data),
    update: (data) => axios.post('products/update', data),
    delete: (id) => axios.post('products/delete', id)
}